export default class address_data {
  constructor(initializer) {
    this.name = initializer.name;
    this.city = initializer.city;
    this.district = initializer.district;
    this.street = initializer.street;
    this.postal_code_city = initializer.postal_code_city;
    this.region = initializer.region;
    this.country = initializer.country;
  }
}
